import React from "react";
import "./HeroStaticVideo2.css";
import parse from "html-react-parser";
import VideoBackground from "../VideoBackground";

function HeroStaticVideo2({ heading, body, colors: colorObj, contents: contentsArray }) {
    const videoSrc = contentsArray?.[0]?.content_reference;

    return (
        <div className="row">
            <div className="col-12">
                <div
                    className="HeroStaticVideo2Main"
                    style={{ "--accent_color1": colorObj?.accent_color1 }}
                    data-aos="fade-up"
                >
                    <VideoBackground src={videoSrc} className="heroVideo" />
                    <div className="contMain container">
                        <h2>{heading}</h2>
                        <p>{body && parse(body)}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeroStaticVideo2;
